import NextImage from 'next/image';

export const Image = NextImage;
